import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Styles } from "./styles";
import { Dropdown, Spinner } from "react-bootstrap";
import { getAllLanguages } from "../../../services/translation.service";
import environment from "../../../environment";
import { useDispatch, useSelector } from "react-redux";
import { setLanguages } from "../../../store/slices/translationSlice";
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const languages = useSelector((state) => state.translation.languages);
  // const [languages, setLanguages] = useState();
  const [isLanguagesLoading, setIsLanguagesLoading] = useState(false);
  const _lang = environment.LANGUAGE;
  const _lang_key = environment.LANGUAGE_KEY;

  const getLanguages = async () => {
    setIsLanguagesLoading(true);
    const response = await getAllLanguages();
    if (response?.status === 200) {
      dispatch(setLanguages(response?.data?.data));
      // setLanguages(response?.data?.data);
      setIsLanguagesLoading(false);
    } else {
      setIsLanguagesLoading(false);
    }
  };

  useEffect(() => {
    if(!languages){
      getLanguages();
    }
  }, [languages]);

  return (
    <Styles>
      <div className="list-container">
        <div className="lang-list">
          <div className="selected-lang">
            {isLanguagesLoading ? (
              <Spinner size="sm" />
            ) : (
              languages?.map((item, idx) => {
                if (i18n?.language === item?.culture) {
                  return (
                    <div className="flag-container" key={idx}>
                      <img src={item?.iconUrl} className="flag" alt="localize-flag" />
                    </div>
                  );
                }
              })
            )}
            <i className="fa-solid fa-angle-down menuArrow"></i>
          </div>
          <ul
            className={
              i18n?.language === "ar"
                ? "sub-lang-menu p-0"
                : "sub-lang-menu sub-lang-menu-en p-0"
            }
          >
            {isLanguagesLoading ? (
              <li>
                <button>
                  <Spinner size="sm" />
                </button>
              </li>
            ) : (
              languages &&
              languages.map((item, idx) => {
                return (
                  <li key={idx}>
                    <button
                      onClick={() => {
                        i18n.changeLanguage(item?.culture);
                        localStorage.setItem(_lang, item?.culture);
                        localStorage.setItem(_lang_key, item?.id);
                        window.location.reload();
                      }}
                    >
                      <div className="flag-container">
                        <img src={item?.iconUrl} className="flag" alt="localize-flag" />
                      </div>
                    </button>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
    </Styles>
  );
};

export default LanguageSwitcher;
